import axiosService from '@/services/axios/axios.service';

const checkUserUsingSocialMedia = async (
    payload: FormData
): Promise<
    NonNullable<{ working: boolean; confidence: number; reason: string } | null>
> => {
    const res = await axiosService.post(
        `/openai/check-user-using-social-media`,
        payload
    );

    return res.data;
};

interface PolishContentPayload {
  text: string;
}

const polishContent = async (payload: PolishContentPayload): Promise<string | null> => {
  const response = await axiosService.post('/openai/polish-content', payload);
  return response.data;
};

export { checkUserUsingSocialMedia, polishContent };
